import Vue from "vue";
import locale from "../../locale/index";
//模块：导航栏
export default Vue.extend({
    name: "index",
    data: function () {
        return {
            lang: {
                zh: { val: 'zh-CN', name: '中' },
                en: { val: 'en-US', name: 'EN' }
            },
            crtLang: '中'
        };
    },
    mounted: function () {
        this.getLocalLang();
    },
    methods: {
        /**
         * 功能：切换路由
         * @param val
         */
        toPage: function (val) {
            this.$router.push(val);
        },
        /**
         * 功能：切换语言
         * @param val
         */
        changeLang: function (val) {
            if (val == "en-US") {
                this.crtLang = 'EN';
            }
            else {
                this.crtLang = '中';
            }
            this.$i18n.locale = val;
            this.$store.state.um.lang = val;
        },
        /**
         * 功能：获取本地语言，设置默认值
         */
        getLocalLang: function () {
            var lang = locale.getLang();
            if (lang == "en-US") {
                this.crtLang = 'EN';
            }
            else {
                this.crtLang = '中';
            }
            this.$i18n.locale = lang;
            this.$store.state.um.lang = lang;
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/iview-loader??ref--0-1!./src/sfc/navigation/index.vue
// module id = null
// module chunks = 